export default "__VITE_ASSET__FRpcXOdd__"